<template>
  <button :class="['lk-toggle-btn', { 'lk-toggle-btn--inherit-color': inheritColor }]" type="button" @click="mv = !mv">
    <slot v-if="mv" name="start-state" />
    <slot v-else name="end-state" />
  </button>
</template>

<script>
export default {
  name: 'LkToggleBtn',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    inheritColor: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mv: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>

<style scoped lang="sass">
.lk-toggle-btn
  display: flex
  align-items: center
  cursor: pointer

  > *
    color: #68696c
    max-width: unset
    height: unset

    &:hover
      opacity: .8

  &.lk-toggle-btn--inherit-color
    > *
      color: inherit
</style>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-toggle-btn/index.vue